import { Injectable } from '@angular/core';
import { TypeIndexation } from '../../models/type.indexation';
import { TypeMotsClef } from '../../models/TypeMotsClef';
import { TypeDept } from '../../models/type.dept';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { CriteresIndexationHelper } from '../../helpers/CriteresIndexationHelper';

@Injectable({
  providedIn: 'root'
})
export class IndexationService {

  dateFormat = 'yyyy-MM-dd';

  constructor(private avisDataTransferService: AvisDataTransferService) { }

  getIndexation(form): TypeIndexation {

    const indexation = new TypeIndexation();

    let typeIndexation = this.avisDataTransferService.avis?.jsonSaisieFormulaire?.ann?.indexation;

    indexation.criteresEnvironnementaux = form.controls._SepSep_TypeIndexation_SepAtt_criteresEnvironnementaux?.value;
    indexation.criteresSociaux = form.controls._SepSep_TypeIndexation_SepAtt_criteresSociaux?.value;

    // Alignement sur le chemin eForms (EformsExtractorService.getIndexation) : les deux critères
    // sont obligatoires, à défaut de valeur saisie ou héritée on les fixe à 'Non'.
    // Remplace l'ancien décodage des valeurs du gabarit serveur ('' / null), qui traitait les deux
    // critères en sens inverse l'un de l'autre et que le back ne renvoie plus (l'API poste et rend
    // désormais 'Oui' / 'Non').
    CriteresIndexationHelper.applyDefaults(indexation, form);

    indexation.nomOrganisme = form.controls._SepSep_TypeIndexation_SepAtt_nomOrganisme?.value;
    if (!indexation.nomOrganisme && typeIndexation?.nomOrganisme) {
      form.controls._SepSep_TypeIndexation_SepAtt_nomOrganisme.value = typeIndexation?.nomOrganisme;
    }
    const objetCtrl = form.controls._SepSep_TypeIndexation_SepAtt_objetAvis;
    indexation.objetAvis = objetCtrl?.value;

    if (typeof indexation.objetAvis === 'string' && indexation.objetAvis.trim().length === 0) {
      objetCtrl?.setValue('');
      indexation.objetAvis = '';
    }
    if (!indexation.objetAvis && typeof typeIndexation?.objetAvis === 'string' && typeIndexation.objetAvis.trim().length > 0) {
      objetCtrl?.setValue(typeIndexation.objetAvis);
      indexation.objetAvis = typeIndexation.objetAvis;
    }
    indexation.dateFinDiffusion = form.controls._SepSep_TypeIndexation_SepAtt_dateFinDiffusion?.value;
    if ((!indexation.dateFinDiffusion || indexation.dateFinDiffusion.toString() === this.dateFormat) && typeIndexation?.dateFinDiffusion) {
      form.controls._SepSep_TypeIndexation_SepAtt_dateFinDiffusion.setValue(typeIndexation?.dateFinDiffusion);
    }
    indexation.motsClef = new TypeMotsClef();
    indexation.motsClef.motClef = form.controls._SepSep_TypeIndexation_SepSep_TypeMotsClef_SepAtt_motClef?.value;
    // Filtrer les valeurs vides du tableau motClef pour éviter les erreurs de validation
    if (Array.isArray(indexation.motsClef.motClef)) {
      indexation.motsClef.motClef = indexation.motsClef.motClef.filter((val: any) => val && typeof val === 'string' && val.trim() !== '');
    }
    if ((!indexation.motsClef.motClef || indexation?.motsClef?.motClef?.length === 0) && typeIndexation?.motsClef?.motClef?.length > 0) {
      const filteredMotClef = typeIndexation.motsClef.motClef.filter((val: any) => val && typeof val === 'string' && val.trim() !== '');
      form.controls._SepSep_TypeIndexation_SepSep_TypeMotsClef_SepAtt_motClef.setValue(filteredMotClef);
      indexation.motsClef.motClef = filteredMotClef;
    }
    indexation.deptPublication = new TypeDept();

    if (form.controls._SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_rappel) {
      // Filtrer les valeurs vides du tableau rappel pour éviter les erreurs de validation
      // et normaliser les valeurs mixtes (objets {code, libelle} ou strings) en codes strings purs
      const rappelValue = form.controls._SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_rappel.value;
      if (Array.isArray(rappelValue)) {
        indexation.deptPublication.rappel = rappelValue
          .map((val: any) => (val && typeof val === 'object' && val.code) ? val.code : val)
          .filter((val: any) => val && typeof val === 'string' && val.trim() !== '');
      } else {
        indexation.deptPublication.rappel = rappelValue;
      }
    }

    if ((!indexation.deptPublication.rappel || indexation?.deptPublication?.rappel?.length === 0) && typeIndexation?.deptPublication?.rappel?.length > 0) {
      // Filtrer également les valeurs vides lors de la restauration depuis typeIndexation
      // et normaliser les objets {code, libelle} éventuellement persistés en codes strings purs
      const filteredRappel = typeIndexation.deptPublication.rappel
        .map((val: any) => (val && typeof val === 'object' && val.code) ? val.code : val)
        .filter((val: any) => val && typeof val === 'string' && val.trim() !== '');
      form.controls._SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_rappel?.setValue(filteredRappel);
      indexation.deptPublication.rappel = filteredRappel;
    }

    if (form.controls._SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub) {
      indexation.deptPublication.deptPub = form.controls._SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub.value;
    }

    if (!indexation?.deptPublication?.deptPub && typeIndexation?.deptPublication?.deptPub) {
      form.controls._SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub?.setValue(typeIndexation?.deptPublication.deptPub);
    }
    return indexation;
  }

}
